import { makePieActionObjs } from "shared/imports/pieActionGenerators"
const prefix = '@@region-selection-page/'

const loadCustomRegionsObjs = makePieActionObjs(`${prefix}get`, "assignments")
export const loadCustomRegionsTypes = loadCustomRegionsObjs.pieDict

const regionSelectorActionTypes = {
    ...loadCustomRegionsTypes,
    UPDATE_FIELD: `${prefix}UPDATE_FIELD`,
}

export default regionSelectorActionTypes
